import imgA from "../../../images/concert/img-a.jpg";
import imgB from "../../../images/concert/img-b.jpg";
import imgC from "../../../images/concert/img-c.jpg";
import imgD from "../../../images/concert/img-d.jpg";
import imgE from "../../../images/concert/img-e.jpg";
import imgF from "../../../images/concert/img-f.jpg";
import imgG from "../../../images/concert/img-g.jpg";
import imgH from "../../../images/concert/img-h.jpg";
import imgI from "../../../images/concert/img-i.jpg";
import imgJ from "../../../images/concert/img-j.jpg";
import imgK from "../../../images/concert/img-k.jpg";
import imgL from "../../../images/concert/img-l.jpg";
import imgM from "../../../images/concert/img-m.jpg";
import imgN from "../../../images/concert/img-n.jpg";
import imgO from "../../../images/concert/img-o.jpg";
import imgP from "../../../images/concert/img-p.jpg";
import imgQ from "../../../images/concert/img-q.jpg";
import imgR from "../../../images/concert/img-r.jpg";
import imgS from "../../../images/concert/img-s.jpg";

export const photos = [
  {
    src: imgA,
    width: 3.5,
    height: 5,
  },
  {
    src: imgB,
    width: 3.5,
    height: 5,
  },
  {
    src: imgC,
    width: 3.5,
    height: 5,
  },
  {
    src: imgD,
    width: 3.5,
    height: 5,
  },
  {
    src: imgE,
    width: 3.5,
    height: 6,
  },
  {
    src: imgF,
    width: 3.5,
    height: 5,
  },
  {
    src: imgG,
    width: 3,
    height: 3,
  },
  {
    src: imgI,
    width: 3.5,
    height: 5,
  },
  {
    src: imgH,
    width: 3,
    height: 3,
  },
  {
    src: imgK,
    width: 3.5,
    height: 5,
  },
  {
    src: imgJ,
    width: 4,
    height: 5,
  },
  {
    src: imgN,
    width: 4,
    height: 3.5,
  },
  {
    src: imgL,
    width: 3,
    height: 3,
  },
  {
    src: imgM,
    width: 3.5,
    height: 5,
  },
  {
    src: imgP,
    width: 3.5,
    height: 5,
  },
  {
    src: imgO,
    width: 4.5,
    height: 3,
  },
  {
    src: imgR,
    width: 3.5,
    height: 5,
  },
  {
    src: imgS,
    width: 3,
    height: 5,
  },
  {
    src: imgQ,
    width: 4,
    height: 4,
  },
];
